import { ready, onShopifySectionLoad } from './utils/readyinit';
import { initSwiper, initSwiperMobile } from './components/swiper';
import initAccordion from './components/accordion';
import initAtcPopup from './components/atc-popup';
import initStoreSwitcherModal from './components/store-switcher-modal';
import initLazyloadVideo from './utils/lazyloadVideo';
import initHeader from './sections/header/header';
import initCustomDropdowns from './components/custom-dropdowns';
import initMinicart from './components/minicart';
import initAtcForm from './components/atcForm';
import initProductCardSwatches from './components/product-card-swatches';
import initTabs from './components/tabs';
import initNewsletter from './components/newsletter';
import initWishlistAtc from './components/wishlistAtc';

ready(() => {
  // First: an earlier init throwing here would otherwise stop this whole
  // synchronous callback, silently skipping every init after it - including
  // this one - with no visible error tying it back to the newsletter form.
  initNewsletter();
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initMinicart();
  initHeader();
  initAccordion();
  initLazyloadVideo();
  initAtcForm();
  initAtcPopup();
  initStoreSwitcherModal();
  initProductCardSwatches();
  initTabs();
  initWishlistAtc();
});

onShopifySectionLoad(() => {
  initNewsletter();
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initHeader();
  initLazyloadVideo();
  initMinicart();
  initAtcForm();
  initProductCardSwatches();
  initTabs();
});
